export default Object.freeze({
  statistic: null,
  adminTabsEnabled: false,
  chipsStrip: '',
  hiddenChips: [],
});
